module.exports = __webpack_public_path__ + "static/img/negz_2.7b0d278.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/3dapps/skybox/tidepool/negz_2.jpg
// module id = DalC
// module chunks = 2